import React from "react";
import { IPopupResultHistoryProps } from "@/types/PopupResultHistoryTypes";
import { renderResultHistory } from "@/modules/commonPopupResultHistory";

import "../index.scss";
import { getBasePcode } from "@/modules/gamePcode";

export default class M34 extends React.PureComponent<IPopupResultHistoryProps> {
    render() {
        const { langdata, orientation } = this.props;

        const basePcode = getBasePcode(this.props.activeGame.pcode);

        const tabNames = ["HILO"];

        const landscapeHeaders = [
			langdata["txt_periode"],
			langdata["txt_number"],
            
            langdata["txt_result"],
			`${langdata["txt_odd"]}-${langdata["txt_even"]}`,
        ];
        
        const portraitHeaderIndices = (
			this.props.portraitTabIndex === 0 ? [0, 1, 2] : null
        );
        
        const bodyMapFunction = (item, idx) => {
            const cells = [
				item.periode,
				
				<div key={"m34_result_" + idx}>
					{item.angka}
                </div>,
                
                (
					+item.angka === 7 ? <div className="bg-green">7</div> :
					+item.angka < 7 ? <div className="bg-red">Lo</div> :
					<div className="bg-blue">Hi</div>
				),
				
				item.angka % 2 ? langdata["txt_odd"] : langdata["txt_even"],
            ];
            
            const landscapeColumns = cells.map((cell, _idx) =>
				<td key={"lC_" + _idx}>
					{cell}
				</td>
			), portraitColumns = portraitHeaderIndices.map((num, _idx) =>
				<td key={"pC_" + this.props.portraitTabIndex + _idx}>
					{ cells[num] }
				</td>
			);
		
			return (
				<tr key={"tpdhm_" + idx}>
					{
						orientation === "landscape" ?
						landscapeColumns : portraitColumns
					}
				</tr>
			);
        };

        const headers = orientation === "landscape" ?
        landscapeHeaders :
        portraitHeaderIndices.map(num => landscapeHeaders[num]);
        
        return renderResultHistory(
            this.props.activeGame.resultHistory,
            basePcode,
            headers,
            bodyMapFunction,
            
            this.props.gameResultHistoryPage,

            this.props.fetchResultHistory,
            this.props.changePortraitResultHistoryTab,
            // null,
            
            {
                mobile: this.props.mobile,
                mobileHome: this.props.mobileHome,
                desktop: this.props.desktop,
                orientation: orientation,
                tabNames: tabNames,
                
                portraitTabIndex: this.props.portraitTabIndex,
                showGameResultHistoryLoadingOverlay: this.props.showGameResultHistoryLoadingOverlay
            }
        );
    }
}